import { map, take } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { loginPanelHashbangTrigger } from '@core/authentication/authentication.config';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { SettingsService } from '@core/services/settings.service';
import { LoginPanelComponent } from '@features/login-panel/login-panel/login-panel.component';

import { RegexService } from '@shared/regex/regex.service';
import { CustomerAccountVerificationResult } from '@models/api-customers.models';
import { ImpactOverlayRef, OverlayService } from '@libs/overlay';

@Injectable({
    providedIn: 'root'
})
export class LoginPanelService {
    constructor(
        private authenticationService: AuthenticationService,
        private overlayService: OverlayService,
        private settingService: SettingsService,
        private router: Router,
        private regexService: RegexService
    ) {}

    public strHasPanelTrigger(str: string): boolean {
        return str.includes(loginPanelHashbangTrigger);
    }

    public triggerPanel(username?: string, userVerified?: CustomerAccountVerificationResult): ImpactOverlayRef {
        return this.overlayService.open(LoginPanelComponent, {
            data: { username, userVerified }
        });
    }

    public triggerClubOrPanel(): void {
        this.authenticationService.loginState$.pipe(take(1)).subscribe(({ loggedIn }) => {
            if (loggedIn) {
                this.settingService.settings$
                    .pipe(
                        take(1),
                        map(({ pageReferences }) => pageReferences?.clubPage)
                    )
                    .subscribe(clubUrl => clubUrl?.url && this.router.navigateByUrl(clubUrl.url));
                return;
            }

            const email = this.getEmail();

            this.triggerPanel(email);
        });
    }

    private getEmail(): string {
        const fragment = this.router.parseUrl(this.router.url).fragment;
        const email = fragment && this.strHasPanelTrigger('#' + fragment) ? fragment.split('=')[1] : '';

        return this.regexService.email.test(email) ? email : '';
    }
}
